// router
import { Outlet } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
// config
import { useWindowDimensions } from "hooks/useWindowDimensions";
import ErrorBoundary from "components/common/ErrorBoundary/ErrorBoundary";

interface StyledOutletProps {
  screenHeight: number;
}

const StyledOutlet = styled("div", {
  shouldForwardProp: (prop: PropertyKey) => prop !== "screenHeight",
})<StyledOutletProps>(({ screenHeight, theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(2),
  // minHeight: `calc(${screenHeight}px)`,
  height: "100%",
  // overflow: "scroll",
  backgroundColor: theme.palette.background.default,
  boxSizing: "border-box",
  paddingTop: "80px",
}));
const StyledPaper = styled("div", {
  shouldForwardProp: (propName) => propName !== "screenHeight",
})<{ screenHeight: number }>(({ theme, screenHeight }) => ({
  width: "100%",
  minHeight: `calc(${screenHeight - 90}px)`,
  // height: "100%",
  padding: theme.spacing(1),
  backgroundColor: theme.palette.background.paper,
  borderRadius: "15px",
}));

export const PagesOutlet = () => {
  const { height } = useWindowDimensions();
  return (
    <ErrorBoundary>
      <StyledOutlet screenHeight={height}>
        <StyledPaper screenHeight={height}>
          <Outlet />
        </StyledPaper>
      </StyledOutlet>
    </ErrorBoundary>
  );
};
